export abstract class Model<T> {

	private _includedRelationProperties: string[];

	constructor() {
		this._includedRelationProperties = [];
	}

	public include(relationProperty: (property: T) => void) {
		const relationPropertyPattern = /\w* ?=> ?\w*\.\w*/i;
		if (!relationPropertyPattern.test(relationProperty.toString()))
			throw ('Invalid include format (' + relationPropertyPattern + '): Error at ModelProperty.ts > include');
		
		if (!this._includedRelationProperties) this._includedRelationProperties = [];
		this._includedRelationProperties.push(this.getRelationPropertyName(relationProperty.toString()));
	}

	public getIncludedRelationProperties(): string[] {
		if (!this._includedRelationProperties) this._includedRelationProperties = [];
		return this._includedRelationProperties.slice(); // slice with no parameters generates clone
	}

	private getRelationPropertyName(includeFunction: string): string {
		return includeFunction.indexOf('.') != -1 ? includeFunction.substr(includeFunction.lastIndexOf('.') + 1) : '';
	}
}

export class ModelProperty {
	name = '';
	type?: string;
	isHidden?: boolean;
	isDisabled?: boolean;
	isArray?: boolean;
	isDictionary?: boolean;
	hideAddButton?: boolean;
	newOnInit?: boolean;
	isObject?: boolean;
	isGeneric?: boolean;
	new?: IInitializer;
	properties?: Function;
	template?: ModelProperty[];
	multiline?: boolean;
	options?: ModelOption[];
	relationKeyObject?: any;
}

export interface IInitializer {
	(): Object;
}

export interface IPropertyReference {
	(): ModelProperty[];
}

export class ModelOption {
	text?: string;
	value?: any;
}
